var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1055.65,
    height: 83.52,
    viewBox: "0 0 1055.65 83.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#2684ff;}.cls-3{fill:#0052cc;}.cls-4{fill:#253858;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28.54,
    y1: 35.57,
    x2: 11.4,
    y2: 65.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2684ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atlassian Marketplace-blue-rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.64,30.56a1.88,1.88,0,0,0-3.2.35L.21,63.36a1.94,1.94,0,0,0,1.74,2.81h22.6a1.87,1.87,0,0,0,1.74-1.07C31.15,55,28.2,39.7,19.64,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.55,1A42.81,42.81,0,0,0,29,43.3L39.94,65.1a1.94,1.94,0,0,0,1.74,1.07h22.6A1.94,1.94,0,0,0,66,63.36L34.85,1A1.83,1.83,0,0,0,31.55,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.63,27.06c0,8,3.73,14.42,18.31,17.23,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-8,4.64a44.89,44.89,0,0,1-21.13-5.72V62.44c4.39,2.15,10.19,4.56,21,4.56,15.25,0,21.29-6.79,21.29-16.9m0,0c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6,0-3.15,2.82-4.47,8-4.47,6.3,0,12.51,1.91,18.39,4.56V14.63a41.57,41.57,0,0,0-18-3.73c-14.09,0-21.38,6.13-21.38,16.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "492.5 11.73 492.5 66.17 504.1 66.17 504.1 24.66 508.99 35.68 525.39 66.17 539.98 66.17 539.98 11.73 528.38 11.73 528.38 46.87 523.98 36.67 510.81 11.73 492.5 11.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 406.04,
    y: 11.73,
    width: 12.68,
    height: 54.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.41,50.1c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6,0-3.15,2.82-4.47,8-4.47,6.3,0,12.51,1.91,18.39,4.56V14.63a41.57,41.57,0,0,0-18-3.73C356.7,10.9,349.4,17,349.4,27.06c0,8,3.73,14.42,18.31,17.23,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-8,4.64a44.89,44.89,0,0,1-21.13-5.72V62.44c4.39,2.15,10.19,4.56,21,4.56,15.25,0,21.29-6.79,21.29-16.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "198.15 11.73 198.15 66.17 224.21 66.17 228.31 54.41 210.91 54.41 210.91 11.73 198.15 11.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.67 11.73 146.67 23.5 160.75 23.5 160.75 66.17 173.51 66.17 173.51 23.5 188.59 23.5 188.59 11.73 146.67 11.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.16,11.73H111.44l-19,54.44H107L109.65,57A36,36,0,0,0,130,57l2.69,9.17h14.5ZM119.8,47.19a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,119.8,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.13,11.73H252.4l-19,54.44h14.5L250.61,57a36,36,0,0,0,20.3,0l2.69,9.17h14.5Zm-8.36,35.46a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,260.77,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M464.4,11.73H447.68l-19,54.44h14.5L445.89,57a36,36,0,0,0,20.3,0l2.69,9.17h14.5ZM456,47.19a24.76,24.76,0,0,1-7-1l7-23.77,7,23.77A24.76,24.76,0,0,1,456,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M588.42,7.68l13.26,33.56,5.43,16.11,5.43-16.11L625.9,7.68H638.8V66.16h-8V13.11l-6.85,21.1L611,66.16h-7.75l-12.73-32-8-21.72V66.16h-8V7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M683.58,58.15c-2.85,5.88-8.19,8.9-15,8.9-11.84,0-17.8-10.06-17.8-23.15,0-12.55,6.23-23.14,18.69-23.14,6.5,0,11.48,2.94,14.15,8.72V21.65h7.66V66.16h-7.66Zm-13,1.78c6.85,0,13-4.36,13-14.24V42.13c0-9.88-5.61-14.24-12.11-14.24-8.63,0-13.09,5.7-13.09,16C658.38,54.59,662.66,59.93,670.58,59.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M710.28,66.16H702.8V21.65h7.48v7.83c2.58-5.25,7-9,15.76-8.46v7.48c-9.79-1-15.76,2-15.76,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M732.62,66.16V3h7.66V42.48l19.14-20.83h10l-20.92,21.9,21.81,22.61H759.86L740.27,45.33V66.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M798.31,67.05c-16.65,0-23.95-9.61-23.95-23.23,0-13.44,7.48-23.06,21-23.06,13.71,0,19.23,9.52,19.23,23.06v3.47H782.11c1.07,7.57,6,12.46,16.47,12.46a39.45,39.45,0,0,0,13.53-2.4v7C808.46,66.34,802.85,67.05,798.31,67.05ZM782,40.7h24.84c-.44-8.28-4.18-13-11.84-13C786.92,27.71,782.82,33,782,40.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M826.79,21.65V12.22h7.48v9.44h11.84v7.12H834.27V52.1c0,3.92,2.31,6.59,7,6.59a24.26,24.26,0,0,0,4.81-.62v7.39a18.37,18.37,0,0,1-5.16.71c-9.52,0-14.15-5.61-14.15-13.89V28.77h-7.21V21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M863.56,58.33V83.52H855.9V21.65h7.66v8c2.85-5.87,8.19-8.9,15-8.9,11.84,0,17.8,10.06,17.8,23.14,0,12.55-6.23,23.15-18.69,23.15C871.21,67.05,866.23,64.12,863.56,58.33Zm13-30.45c-6.85,0-13,4.36-13,14.24v3.56c0,9.88,5.61,14.24,12.11,14.24,8.63,0,13.09-5.7,13.09-16C888.75,33.22,884.48,27.88,876.55,27.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M917.23,66.43c-7.3,0-11.93-3.47-11.93-11.66V3H913V53.88c0,4,2.67,5.43,6,5.43a19.4,19.4,0,0,0,2.23-.09v6.85A16.28,16.28,0,0,1,917.23,66.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M958.71,58.15c-2.85,5.88-8.19,8.9-15,8.9-11.84,0-17.8-10.06-17.8-23.15,0-12.55,6.23-23.14,18.69-23.14,6.5,0,11.48,2.94,14.15,8.72V21.65h7.66V66.16h-7.66Zm-13,1.78c6.85,0,13-4.36,13-14.24V42.13c0-9.88-5.61-14.24-12.11-14.24-8.63,0-13.09,5.7-13.09,16C933.52,54.59,937.79,59.93,945.71,59.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1009.36,65c-2.67,1.42-6.77,2-10.86,2-15.85,0-23.23-9.61-23.23-23.23,0-13.44,7.39-23.06,23.23-23.06a23.54,23.54,0,0,1,10.59,2.14V30A22.43,22.43,0,0,0,999,27.88c-11.57,0-16.29,7.3-16.29,15.93s4.81,15.93,16.47,15.93a28.11,28.11,0,0,0,10.15-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1039.36,67.05c-16.65,0-23.95-9.61-23.95-23.23,0-13.44,7.48-23.06,21-23.06,13.71,0,19.23,9.52,19.23,23.06v3.47h-32.49c1.07,7.57,6,12.46,16.47,12.46a39.45,39.45,0,0,0,13.53-2.4v7C1049.5,66.34,1043.9,67.05,1039.36,67.05ZM1023.07,40.7h24.84c-.45-8.28-4.18-13-11.84-13C1028,27.71,1023.87,33,1023.07,40.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarketplace);
export default __webpack_public_path__ + "static/media/logo-marketplace.1b812041d934627a163d9aa5fc3619af.svg";
export { ForwardRef as ReactComponent };